import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import {
    mdiHome,
    mdiClipboardTextOutline,
    mdiPrinter,
    mdiClose,
} from "@mdi/js";

import { getUrl } from "utils/utils";
import "react-dropdown/style.css";
import PageNotRole from "components/ComponentImport/PageNotRole";
import { getUserLogin } from "utils/utils";
import LayoutNew from "common/LayoutNew";
import { Breadcrumb } from "common/Breadcrumb";
import { TitlePage } from "common/TitlePage";
import moment from "moment";
import { SearchBar } from "./SearchBar";
import { TableDanhSach } from "./TableDanhSach";

// import { BtnInDanhSach } from "./Print/InDanhSach/BtnInDanhSach";
// import { BtnInNhanh } from "./Print/InNhanh/BtnInNhanh";
// import { BtnInLenhCat } from "./Print/InLenhCat/BtnInLenhCat";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import configs from "../../../constants/configs";
import { BtnInDanhSachRp } from "./Print/InDanhSach/BtnInDanhSachRp";

export const DanhSachDonHang = () => {
    const dispatch = useDispatch();
    const listDonHang = useSelector((state) => state.listDanhSachDonHang);
    const [getLink, setGetLink] = useState();
    useEffect(() => {
        //gọi cấu hình
        dispatch(Index_GetConfigAllSTKey());

    }, []);

    // cấu hình
    const [isShowTinhThanh, setIsShowTinhThanh] = useState(null);
    const [isShowNVKD, setIsShowNVKD] = useState(null);
    const [isConfigChot, setConfigChot] = useState(null);
    const [isConfigMaPO, setIsConfigMaPO] = useState(null);
    const [isConfigThongTinLSX, setIsConfigThongTinLSX] = useState(null);

    const [isLamTronTien, setLamTronTien] = useState(null);

    const [isEditDHCheckTrangThaiKho, setIsEditDHCheckTrangThaiKho] =
        useState(null);
    const danhmuc = useSelector((state) => state.danhmuc);
    const { objConfigAll } = danhmuc;

    if (
        objConfigAll.List.length > 0 &&
        isShowTinhThanh === null &&
        isConfigChot === null &&
        isShowNVKD === null &&
        isConfigMaPO === null &&
        isEditDHCheckTrangThaiKho === null &&
        isLamTronTien == null
    ) {
        const configLamTronTIen = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
        );
        setLamTronTien(true);
        if (
            typeof configLamTronTIen !== "undefined" &&
            configLamTronTIen != null &&
            configLamTronTIen.Value
        ) {
            if (configLamTronTIen.Value === "1") {
                setLamTronTien(false);
            }
        }
        //
        const configShowTinhThanh = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.BanHangLocTinhThanh.toUpperCase()
        );
        console.log("configShowTinhThanh", configShowTinhThanh);

        setIsShowTinhThanh(false);
        if (
            typeof configShowTinhThanh !== "undefined" &&
            configShowTinhThanh != null &&
            configShowTinhThanh.Value
        ) {
            if (configShowTinhThanh.Value === "1") {
                setIsShowTinhThanh(true);
            }
        }
        const configNVKD = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() ===
                configs.sKey.shownhanvienkinhdoanh.toUpperCase()
        );
        setIsShowNVKD(false);
        if (
            typeof configNVKD !== "undefined" &&
            configNVKD != null &&
            configNVKD.Value
        ) {
            if (configNVKD.Value === "1") {
                setIsShowNVKD(true);
            }
        }
        //
        const stKeyChot = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.ConfigBaoGiaChot.toUpperCase()
        );
        setConfigChot(false);
        if (
            typeof stKeyChot !== "undefined" &&
            stKeyChot != null &&
            stKeyChot.Value
        ) {
            if ((isConfigChot ? "1" : "0") !== stKeyChot.Value)
                if (stKeyChot.Value == "1") setConfigChot(true);
                else setConfigChot(false);
        }
        //
        const configPO = objConfigAll.List.find(
            (e) => e.KeyID.toUpperCase() === configs.sKey.ConfigMaPO.toUpperCase()
        );
        setIsConfigMaPO(false);
        if (typeof configPO !== "undefined" && configPO != null && configPO.Value) {
            if (configPO.Value === "1") {
                setIsConfigMaPO(true);
            }
        }
        const configThongTinLSX = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.ConfigThongTinLSX.toUpperCase()
        );
        setIsConfigThongTinLSX(false);
        if (
            typeof configThongTinLSX !== "undefined" &&
            configThongTinLSX != null &&
            configThongTinLSX.Value
        ) {
            if (configThongTinLSX.Value === "1") {
                setIsConfigThongTinLSX(true);
            }
        }

        //
        const configEditDHCheckTrangThaiKho = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() ===
                configs.sKey.EditOrderUpdateStore.toUpperCase()
        );
        setIsEditDHCheckTrangThaiKho(false);
        if (
            typeof configEditDHCheckTrangThaiKho !== "undefined" &&
            configEditDHCheckTrangThaiKho != null &&
            configEditDHCheckTrangThaiKho.Value
        ) {
            if (configEditDHCheckTrangThaiKho.Value === "1") {
                setIsEditDHCheckTrangThaiKho(true);
            }
        }
        //
    }
    //
    const user = useSelector((state) => state.user);
    let { AllRoleUser } = user;
    const [roleEditDH, setRoleEditDH] = useState();
    const [roleXoaDH, setRoleXoaDH] = useState();
    const [roleDuyetYeuCau, setRoleDuyetYeuCau] = useState();
    const [roleEditDHQuaNgay, setRoleEditDHQuaNgay] = useState();
    console.log(AllRoleUser, "AllRoleUserAllRoleUserAllRoleUser");
    const [configLenhSanXuat, setConfigLenhSanXuat] = useState();
    if (typeof AllRoleUser.List != "undefined" && configLenhSanXuat == null) {
        var sRoleViewLSX = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.LSX_TAOLENH.toUpperCase()
        );
        if (sRoleViewLSX != null) {
            setConfigLenhSanXuat(true);
        } else {
            setConfigLenhSanXuat(false);
        }
        console.log(1111111111111, configLenhSanXuat);
    }
    if (
        typeof AllRoleUser.List != "undefined" &&
        roleEditDH == null &&
        roleXoaDH == null &&
        roleDuyetYeuCau == null &&
        roleEditDHQuaNgay == null
    ) {
        var sRoleEditDH = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.BANHANG_SUADH.toUpperCase()
        );

        if (sRoleEditDH != null) {
            setRoleEditDH(true);
        } else {
            setRoleEditDH(false);
        }
        //
        var sRoleXoaDH = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.BANHANG_XOADH.toUpperCase()
        );

        if (sRoleXoaDH != null) {
            setRoleXoaDH(true);
        } else {
            setRoleXoaDH(false);
        }
        //
        var sRoleDuyetYeuCau = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.HT_DUYETYEUCAU.toUpperCase()
        );

        if (sRoleDuyetYeuCau != null) {
            setRoleDuyetYeuCau(true);
        } else {
            setRoleDuyetYeuCau(false);
        }
        //
        var sRoleSuaDHQuaNgay = AllRoleUser.List.find(
            (e) =>
                e.toUpperCase() === configs.sRole.BANHANG_SUADHQUANGAY.toUpperCase()
        );
        console.log(sRoleSuaDHQuaNgay, "sRoleDuyetYeuCausRoleDuyetYeuCau");
        if (sRoleSuaDHQuaNgay != null) {
            setRoleEditDHQuaNgay(true);
        } else {
            setRoleEditDHQuaNgay(false);
        }
    }
    const [isCheckInNhanh, setIsCheckInNhanh] = useState(false);
    return (
        <LayoutNew isProgress={listDonHang.isProgress}>
            <div className="bg-main-content">
                <div className="header-main">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="title-Search-ver2">
                                <TitlePage
                                    titlePage="Danh sách đơn hàng"
                                    IconTitle={mdiClipboardTextOutline}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">

                            <div className="align-end ">
                                <BtnInDanhSachRp />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="title-main-15">
                    <SearchBar
                        isShowTinhThanh={isShowTinhThanh}
                        isShowNVKD={isShowNVKD}
                        isConfigChot={isConfigChot}
                        isConfigMaPO={isConfigMaPO}
                    />
                    <TableDanhSach
                        configLenhSanXuat={configLenhSanXuat}
                        isConfigMaPO={isConfigMaPO}
                        isConfigThongTinLSX={isConfigThongTinLSX}
                        isLamTronTien={isLamTronTien}
                        roleEditDH={roleEditDH}
                        isEditDHCheckTrangThaiKho={isEditDHCheckTrangThaiKho}
                        isCheckInNhanh={isCheckInNhanh}
                        setIsCheckInNhanh={setIsCheckInNhanh}
                        roleXoaDH={roleXoaDH}
                        roleDuyetYeuCau={roleDuyetYeuCau}
                        roleEditDHQuaNgay={roleEditDHQuaNgay}
                    />
                    {/* <div
                    className={isModalVisible ? "bg-search-active" : ""}
                  ></div> */}
                </div>
            </div>
        </LayoutNew>
    );
};
